import _ from 'underscore';
import moment from 'moment';

import flight_domestic_buyer_manage_order_refList from '@/lib/data-service/flight/flight_domestic_buyer_manage_order_refList'
import flight_domestic_buyer_manage_order_refStates
  from '@/lib/data-service/flight/flight_domestic_buyer_manage_order_refStates'
import flight_domestic_airlines from '@/lib/data-service/flight/flight_domestic_airlines'
import order_cancel from '@/lib/data-service/flight/flight_domestic_buyer_white_order_cancel'
import scrollTop from '@/lib/common-service/scrollTop'
import refundRecordCount from '@/lib/data-service/flight/flight_domestic_buyer_manage_order_refundRecordCount'
import confirmRefund from '@/lib/data-service/flight/newFligthApi/buyer_dom_manage_confirmRefund'
import cancelRefund from '@/lib/data-service/flight/newFligthApi/buyer_dom_manage_cancelRefund'
import FligthTime from '../component/flightTimeBox'
import AirlineSelect from '../../components/airlineSelect'


export default {
  components: { FligthTime, AirlineSelect },
  data() {
    return {
      timeUpbox: null,
      timeUpboxHeight: null,
      searchForm: {
        pnr: ``,
        orderNo: ``,
        ticketNumber: ``,

        airCode: ``,
        psgName: ``,

        __orderTimeStart: ``,
        __orderTimeEnd: ``,

        refundStatus: 1,
      },
      cancelOrderNo: '',
      dialogVisible: false,
      pageResult: {
        currentPage: 1,
        pageSize: 10,
        pageData: [],
        totalCount: 0,
      },
      pCurrentPage: 1,
      data_flight_domestic_airlines: {
        pageResult: {
          pageData: [],
        }
      },

      data_flight_domestic_buyer_manage_order_refStates: {
        pageResult: {
          pageData: [],
        }
      },
      refundRecordCountList: [],
      loading: true,
      NavItemActive: 0,
      dialogInfo: {
        text: "",
        type: 1
      }
    };
  },
  computed: {
    orderTimeStart: {
      get() {
        const __this = this;
        const flag = moment(__this.searchForm.__orderTimeStart).isValid();
        let s = ``;
        if (flag) {
          const d = moment(__this.searchForm.__orderTimeStart);
          s = d.format(`YYYY/MM/DD`);
        }
        return s;
      }
    },
    orderTimeEnd: {
      get() {
        const __this = this;
        const flag = moment(__this.searchForm.__orderTimeEnd).isValid();
        let s = ``;
        if (flag) {
          const d = moment(__this.searchForm.__orderTimeEnd);
          s = d.format(`YYYY/MM/DD`);
        }
        return s;
      }
    },
  },
  methods: {
    confirm() {
      let orderNo = this.dialogInfo.orderNo
      let type = this.dialogInfo.type
      if (type == 2) {
        confirmRefund({ refOrderNo: orderNo }).then(res => {
          console.log(res)
          if (res.status) {
            this.dialogVisible = false
            this.__data_bind_list()
            this.$message({ type: "success", message: "确认退票成功！" })
          }
        })
      } else {
        cancelRefund({ refOrderNo: orderNo }).then(res => {
          this.dialogVisible = false
          this.__data_bind_list()
          this.$message({ type: "success", message: "取消退票成功！" })
        })
      }
    },
    async __data_bind_list(pParameter) {
      const __this = this;
      if (!pParameter) pParameter = {};
      const currentPage = pParameter.currentPage || __this.pageResult.currentPage;
      const pageSize = pParameter.pageSize || __this.pageResult.pageSize;

      const pnr = __this.searchForm.pnr;
      const orderNo = __this.searchForm.orderNo;
      const ticketNumber = __this.searchForm.ticketNumber;
      const airCode = __this.searchForm.airCode;
      const psgName = __this.searchForm.psgName;
      const refundStatus = __this.searchForm.refundStatus;
      let _fromData = this.searchForm
      const orderTimeStart = __this.orderTimeStart;
      const orderTimeEnd = __this.orderTimeEnd;
      let data = {
        currentPage: currentPage,
        pageSize: pageSize,
        pnr: pnr,
        orderNo: orderNo,
        ticketNumber: ticketNumber,
        airCode: airCode,
        psgName: psgName,
        refundStatus: refundStatus,
        orderTimeStart: orderTimeStart,
        orderTimeEnd: orderTimeEnd,
        flightNo: _fromData.flightNo,
        contactTel: _fromData.contactTel,
        psgCardNo: _fromData.psgCardNo
      }
      __this.loading = true;
      flight_domestic_buyer_manage_order_refList(data).then(res => {
        __this.pageResult.pageData = res.pageResult.pageData || [];
        __this.pageResult.totalCount = res.pageResult.totalCount;
        __this.loading = false;
        this._refundRecordCount(data)
        scrollTop(500)
      }).catch(error => {
        __this.pageResult.pageData = []
        __this.pageResult.totalCount = 0
        __this.loading = false;
      })
    },

    __el_pagination_current_change_event_handler(pCurrentPage) {
      const __this = this;
      __this.pageResult.currentPage = pCurrentPage
      __this.__data_bind_list();
    },

    setOrdersNo(ordersNo, toString, psgList) {
      let psgType
      if (psgList) {
        let psg = psgList.map(item => {
          return item.psgType
        })
        if (psg.indexOf(1) != -1) {
          psgType = 1
        } else {
          psgType = 2
        }
      }
      // if(type=='pay'){
      //   return this.$router.push({name:toString,query:{ordersNo:ordersNo,pay:'12'}})
      // }
      this.$router.push({
        name: toString,
        query: {
          ordersNo,
          psgType,
          orderType: 'refund'
        }
      })
    },

    cancel(ordersNo) {
      let parame = {
        orderNo: ordersNo,
        remark: ''
      }
      order_cancel(parame).then(res => {
        res.isSuccess ?
          this.$message({ type: "warning", message: "操作成功！" }) : ''
        this.__data_bind_list({ currentPage: this.pCurrentPage })
      })
    },
    _refundRecordCount(val) {
      refundRecordCount(val).then(res => {
        this.refundRecordCountList = res.records
      })
    },
    __el_pagination_size_change_event_handler(pPageSize) {
      const __this = this;
      __this.pageResult.pageSize = pPageSize
      __this.__data_bind_list();
    },

    __btn_search_click(val) {
      const __this = this;
      __this.__data_bind_list({ currentPage: 1 });
    },

    __btn_reset_click() {
      const __this = this;

      _.each(__this.searchForm, function (property_value, property_name) {
        __this.searchForm[property_name] = ``;
      });
      __this.searchForm.refundStatus = `1`;

      __this.__data_bind_list();
    },

    __btn_tab_click(pItem, pIndex) {
      const __this = this;
      __this.searchForm.refundStatus = pItem.status;
      __this.NavItemActive = pIndex;
      this.pageResult.currentPage = 1
      __this.__btn_search_click();
    },
    offHeight(e) {
      this.timeUpboxHeight = e.target.offsetParent.offsetHeight
      // this.timeUpboxHeight = e.fromElement.localName == 'td' ? e.fromElement.offsetHeight : 0
    }
  },
  watch: {
    '$route.query.ordersNo': function (newId) {
      this.__data_bind_list()
    }
  },
  async mounted() {
    const __this = this;

    const data_flight_domestic_airlines = await flight_domestic_airlines();
    __this.data_flight_domestic_airlines = data_flight_domestic_airlines;

    // const data_flight_domestic_buyer_manage_order_refStates = await flight_domestic_buyer_manage_order_refStates();
    // __this.data_flight_domestic_buyer_manage_order_refStates = data_flight_domestic_buyer_manage_order_refStates;

    __this.__data_bind_list();
  },
}
